import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "upload-file"
};
import { ref } from 'vue';
/**
 * 添加佐证以及预览佐证组件
 */
import { uploadObs } from 'hxhy-obs';
import { MessagePlugin } from 'tdesign-vue-next';
import { getFileType } from '@/utils/index';
import { getStore } from '@/util/store';
export default {
  __name: 'index',
  props: {
    maxCount: {
      // 文件最大上传数
      type: [String, Number],
      default: 10
    },
    maxSize: {
      // 文件最大 size 单位M
      type: [String, Number],
      default: 50
    },
    onSuccess: {
      // 上传成功
      type: Function,
      default: function _default() {}
    },
    onError: {
      // 上传失败
      type: Function,
      default: function _default() {}
    },
    onExceed: {
      // 文件超出个数限制
      type: Function,
      default: function _default() {}
    },
    onDelete: {
      // 文件删除
      type: Function,
      default: function _default() {}
    }
  },
  emits: ['upload'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var fileList = ref([]);
    var loading = ref(false);

    // 选择文件
    var handleSelectFile = function handleSelectFile() {
      var input = document.createElement('input');
      input.type = 'file';
      input.multiple = 'multiple';
      input.accept = 'image/*'; // 只允许选择图片文件
      input.addEventListener('change', /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
          var files, i, file, size;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                files = event.target.files;
                if (!(files.length > props.maxCount)) {
                  _context.n = 1;
                  break;
                }
                props.onExceed(files);
                return _context.a(2, MessagePlugin.error('单次上传文件不能超过' + props.maxCount + '个'));
              case 1:
                i = 0;
              case 2:
                if (!(i < files.length)) {
                  _context.n = 8;
                  break;
                }
                file = files[i];
                if (!file) {
                  _context.n = 7;
                  break;
                }
                // 尺寸校验
                size = (file.size / 1024 / 1024).toFixed(0); // M
                if (!(size >= Number(props.maxSize))) {
                  _context.n = 4;
                  break;
                }
                _context.n = 3;
                return MessagePlugin.error('上传文件大小不能超过' + props.maxSize + 'M');
              case 3:
                return _context.a(3, 8);
              case 4:
                if (file.type.startsWith('image/')) {
                  _context.n = 6;
                  break;
                }
                _context.n = 5;
                return MessagePlugin.error('只能上传图片文件');
              case 5:
                return _context.a(3, 7);
              case 6:
                _context.n = 7;
                return handleUploadFile(file);
              case 7:
                i++;
                _context.n = 2;
                break;
              case 8:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
      input.click();
    };

    // 上传文件
    var handleUploadFile = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(file) {
        var envKey, _ref4, user_id, username, _ref5, institutionId, institutionName, fileInfo, key, bucketEnvSuffix, options, result, fileURL, fileItem, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              envKey = ['dev', 'test', 'pre', 'prod'];
              _ref4 = getStore({
                name: 'accessInfo'
              }) || {}, user_id = _ref4.user_id, username = _ref4.username;
              _ref5 = getStore({
                name: 'userInfo'
              }) || {}, institutionId = _ref5.institutionId, institutionName = _ref5.institutionName;
              fileInfo = getFileType(file.name);
              key = fileInfo.key;
              bucketEnvSuffix = envKey.find(function (v) {
                return location.host.includes(v);
              }) || 'prod'; // 桶名环境值 （dev、test、pre、prod）
              options = {
                bucketName: "hxhy-evaluate-".concat(bucketEnvSuffix),
                // 桶业务名
                file: file,
                fileType: key,
                // fileType 文件类型 (1文本/文档, 2图像/图片, 3视频, 4音频, 5压缩包, 6其他)
                userId: user_id,
                // 用户id
                userName: username,
                // 用户名
                institutionId: institutionId,
                // 用户所在机构id
                institutionName: institutionName,
                // 用户所在机构名
                appCode: 'comprehensive-evaluate',
                // 应用别名（比如：course）
                appName: '综合素质评价',
                // 应用名称（比如：平台官网管理）
                pageName: 'comprehensive-evaluate',
                // 当前页面（比如：columnContent）
                btnName: '添加佐证',
                //  上传按钮的备注信息（页面的哪个按钮触发的上传，比如：新建文章、上传封面等，文字自拟）
                uploadType: 0 // 上传类型 0前端上传 1安卓端/IOS上传 2后端上传
              };
              _context2.p = 1;
              loading.value = true;
              _context2.n = 2;
              return uploadObs(options);
            case 2:
              result = _context2.v;
              fileURL = /^(https?:\/\/)/i.test(result) ? result : "https:".concat(result);
              fileItem = {
                url: fileURL,
                name: file.name
              };
              fileList.value.push(fileItem);
              props.onSuccess(fileList.value);
              emit('upload', fileList.value);
              console.log(fileList.value);
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              props.onError(_t, file);
              console.log('upload2obs', _t);
              MessagePlugin.error((_t === null || _t === void 0 ? void 0 : _t.message) || '上传失败，请重试');
            case 4:
              _context2.p = 4;
              loading.value = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3, 4, 5]]);
      }));
      return function handleUploadFile(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_button = _resolveComponent("t-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_t_button, {
        variant: "outline",
        loading: loading.value,
        onClick: handleSelectFile
      }, {
        icon: _withCtx(function () {
          return [_createVNode(_component_svg_icon, {
            class: "plus",
            size: "11",
            name: "add-file"
          })];
        }),
        default: _withCtx(function () {
          return [_createTextVNode(" " + _toDisplayString(loading.value ? '正在上传' : '添加佐证'), 1)];
        }),
        _: 1
      }, 8, ["loading"])]);
    };
  }
};